import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'
import { useAuthStore } from '../stores/auth'
import { LanguageSwitcher } from './LanguageSwitcher'

export function NavigationBar() {
  const { t } = useTranslation(['home', 'common'])
  const { parent, logout } = useAuthStore()
  const navigate = useNavigate()

  const handleLogout = async () => {
    try {
      await logout()
      // Redirect to login page after logout
      navigate('/login')
    } catch (error) {
      // Logout error handling
    }
  }

  return (
    <nav className="relative z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <div className="flex-shrink-0 flex items-center">
              <Link to="/">
                <img src="/images/logo.png" alt="Logo" className="h-12 w-auto" />
              </Link>
            </div>
          </div>
          
          <div className="flex items-center space-x-6">
            <LanguageSwitcher />
            <button
              onClick={handleLogout}
              className="btn-neobrutalism bg-neobrutalism-red text-xs sm:text-base py-2 sm:py-3 px-2 sm:px-4"
            >
              {t('navigation.logout', { ns: 'common' })}
            </button>
          </div>
        </div>
      </div>
    </nav>
  )
} 